import React from 'react';


export default function UsersTableRow(props) {
  if (props.currentUser === null) {
    return null;
  }

    return (
        <span>
            <button className="btn btn-primary" data-toggle="tooltip" data-placement="top" title="Rollen aanpassen" disabled={props.user.key === props.currentUser.uid}
                onClick={() => {
                    props.functions.openEditUserRolesModal(props.user);
                }}>
                <i className="material-icons">vpn_key</i>
            </button>
        </span>
    )
}
